module.exports = __webpack_public_path__ + "img/arcane-sanctuary-run.33e1566d.png";